import type { ReactNode, ButtonHTMLAttributes } from 'react';
import { CloseIcon } from './icons/CloseIcon';

export function Header({ onClose }: { onClose?: () => void }) {
  return (
    <header className="flex h-[84px] w-full items-center justify-between pl-l2 pr-l py-l">
      <p className="text-[14px] font-medium leading-[20px] text-content-muted">
        Set up your Google Postmaster Tools
      </p>
      <IconButton aria-label="Close" onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </header>
  );
}

export function Button({
  children,
  disabled,
  className = '',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`flex h-[40px] items-center justify-center gap-3 rounded-[6px] px-[17px] py-px text-[14px] font-medium leading-[20px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-shade-12 ${
        disabled
          ? 'cursor-not-allowed bg-[#E7E5E4] text-[#887F7C]'
          : 'bg-shade-12 text-shade-2 transition-opacity hover:opacity-90'
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function IconButton({ children, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      className="flex size-9 items-center justify-center rounded-[3px] text-content-muted transition-colors hover:bg-black/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-shade-12"
      {...props}
    >
      {children}
    </button>
  );
}

export function VideoFrame({ children }: { children?: ReactNode }) {
  return (
    <div className="relative h-[540px] w-[960px] overflow-hidden rounded-[10px] bg-[#E2E2E2] shadow-[0_1px_1px_-0.1px_rgba(0,0,0,0.05),0_1.98px_3.06px_-0.36px_rgba(0,0,0,0.05),0_5.881px_14.045px_-1.944px_rgba(0,0,0,0.09),0_23.287px_85.958px_-13.997px_rgba(0,0,0,0.19)]">
      {children}
    </div>
  );
}
